/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeAccountVerifyResponse
 */
export interface StripeAccountVerifyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StripeAccountVerifyResponse
     */
    isAccountConnected: boolean;
}

/**
 * Check if a given object implements the StripeAccountVerifyResponse interface.
 */
export function instanceOfStripeAccountVerifyResponse(value: object): value is StripeAccountVerifyResponse {
    if (!('isAccountConnected' in value) || value['isAccountConnected'] === undefined) return false;
    return true;
}

export function StripeAccountVerifyResponseFromJSON(json: any): StripeAccountVerifyResponse {
    return StripeAccountVerifyResponseFromJSONTyped(json, false);
}

export function StripeAccountVerifyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeAccountVerifyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isAccountConnected': json['isAccountConnected'],
    };
}

export function StripeAccountVerifyResponseToJSON(json: any): StripeAccountVerifyResponse {
    return StripeAccountVerifyResponseToJSONTyped(json, false);
}

export function StripeAccountVerifyResponseToJSONTyped(value?: StripeAccountVerifyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isAccountConnected': value['isAccountConnected'],
    };
}

